import { PlanModelInfo, planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';

export default (planMapJSON) => {
  return defaultMapper(planMapJSON['zenmd'], planTypes.ZOOM_ENHANCED_MEDIA).map((p) => {
    return {
      ...p,
      category: 'zenmd',
      typeNameKey: 'billing.zoom_enhanced_media.title',
      planNameKey: 'billing.zoom_enhanced_media.title',
      unit: planUnitMap.user,
      planModel: PlanModelInfo.license
    };
  });
}
